export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "API.functional.worker.js?e3a895072fb24018f6be");
}
